import Vue from 'vue'
import Vuex from 'vuex'
import Axios from 'axios'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        events: [],
        selectedDay: {},
        filters: {}

    },
    mutations: {
        setEvents: (state, payload) => {
            state.events = payload;
        },
        setSelectedDay: (state, payload) => {
            state.selectedDay = payload;
        },
        setFilters: (state, payload) => {
            state.filters = payload;
        },
    },
    getters: {
        getEvents: state => {
            return state.events;
        },
        getSelectedDay: state => {
            return state.selectedDay
        },
        getFilters: state => {
            return state.filters;
        },
    },
    actions: {
        fetchEvents: ({ commit }) => {
            return new Promise((resolve, reject) => {
                try {
                    var url = '/wp-json/dgth-calendar/events/sorted_by_date';

                    Axios.get(url)
                        .then((response) => {
                            console.log('Initial: ', response);
                            commit('setEvents',
                                response.data.map(({title, date_start, date_end, ...rest}) => ({
                                    title: title,
                                    start: date_start,
                                    end: date_end ? date_end : date_start,
                                    extenderProps: {...rest}
                                })));
                            resolve();
                        });

                } catch (ex) {
                    console.log('Error with getting events');
                    throw new Error(ex);
                }
            });

        },
        /**
         *
         * @param commit
         * @param state
         * @param filter {object}
         * @returns {Promise<any>}
         */
        fetchEventsByFilter: ( { commit }, filter) => {
            return new Promise((resolve, reject) => {
                try {
                    var url = `/wp-json/dgth-calendar/events/q?${filter}`;

                    Axios.get(url)
                        .then((response) => {
                            console.log('Response: ', response);
                            commit('setEvents',
                                response.data.map(({title, date_start, date_end, ...rest}) => ({
                                    title: title,
                                    start: date_start,
                                    end: date_end ? date_end : date_start,
                                    extenderProps: {...rest}
                                })));
                            resolve();
                        });

                } catch (ex) {
                    console.log('Error with getting events z');
                    throw new Error(ex);
                }
            });
        },
        setSelectedDay: ({ commit }, payload) => {
            commit('setSelectedDay', payload)
        },
        fetchFilters: ({ commit }) => {
            return new Promise((resolve, reject) => {
                try {
                    var url = `/wp-json/dgth-calendar/events/filters`;

                    Axios.get(url)
                        .then((response) => {
                            commit('setFilters', response.data);
                            resolve();
                        });

                } catch (ex) {
                    console.log('Error with getting filters');
                    throw new Error(ex);
                }
            });
        }
    },
    modules: {
    }
})



// WEBPACK FOOTER //
// ./src/store/index.js